import { useNavigate, useLocation } from "react-router-dom";
import i18n from "i18next";

/**
 * This hook allows:
 * 1. Navigating to a route with the current language prefix
 * 2. Changing the language and updating the URL to match
 */
const useNavigateWithLang = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const lng = i18n.language;

    /**
     * Navigates to a path with the current language prefix
     */
    const goTo = (path: string) => {
        navigate(`/${lng}${path.startsWith("/") ? path : `/${path}`}`);
    };

    /**
     * Changes the language and updates the URL to match
     */
    const changeLanguage = (newLang: string) => {
        if (newLang === i18n.language) return;

        i18n.changeLanguage(newLang);

        // Get path after current /lng/
        const currentPath = location.pathname.split("/").slice(2).join("/");
        navigate(`/${newLang}/${currentPath}`);
    };

    const getLocalizedPath = (path: string) => {
        return `/${lng}${path.startsWith("/") ? path : `/${path}`}`;
    };

    return {
        navigateWithLang: goTo,
        changeLanguage,
        getLocalizedPath,
    };
};

export default useNavigateWithLang;
